export default "__VITE_ASSET__Djqf6_h6__"